"use client";

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

const buildRobots = (input: { noIndex?: boolean; noFollow?: boolean }) => {
  return [
    input.noIndex ? "noindex" : "index",
    input.noFollow ? "nofollow" : "follow",
  ].join(", ")
}

interface Props {
  title: string
  description: string
  icon?: string
  noIndex?: boolean
  noFollow?: boolean
}

const PageSEO = ({ title, description, noFollow, noIndex, icon }: Props) => {
  useEffect(() => {
    document.title = title;

    // Add or update the description meta tag
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Add or update robots meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', buildRobots({ noFollow, noIndex }));

    // Add or update icon if provided
    if (icon) {
      let linkIcon = document.querySelector('link[rel="icon"]');
      if (!linkIcon) {
        linkIcon = document.createElement('link');
        linkIcon.setAttribute('rel', 'icon');
        document.head.appendChild(linkIcon);
      }
      linkIcon.setAttribute('href', icon);
    }
  }, [title, description, noFollow, noIndex, icon]);

  // This component doesn't render anything visible
  return null;
}

export default PageSEO